export default __webpack_public_path__ + "static/media/chevron-right.inline.01ca78af.svg";